import React from 'react'
import { TagGroup, Tag, Row, Col } from 'rsuite'
export default function SearchTagView({ schema, ...props }) {
  return (
    <TagGroup style={{ padding: 10 }}>
      {schema?.searchTag?.values.map((item, index) => {
        return (
          <Tag key={index} color="orange">
            {item.value}
          </Tag>
        )
      })}
    </TagGroup>
  )
}
